import React from 'react'
import { BRow, BCol, BTitle, BCardBody, BButton } from '@prague-digi/ui-components'
import messages from '../../../../i18n'
import money from '../../../../assets/money-hand.svg'
import tickDone from '../../../../assets/tickDone.svg'
import { URL } from '../../../../constants'
import styles from './styles.scss'
import { getOpenApiInstance } from '../../../../api/api'
import { openLinkNewTab } from '../../../../utils/url'

interface Props {
  translateHTML: any
  translate: any
}

export const BusinessDenial = ({ translate, translateHTML }: Props) => {
  const goToBusinessLoan = () => {
    getOpenApiInstance()
      .trackFinishToBusinessLoan({})
      .then(() => openLinkNewTab(URL.MONETA_BUSINESS_LOAN))
  }

  return (
    <BCardBody dark theme="mt-4">
      <BRow>
        <BCol xs={12} theme="text-center">
          <img src={money} alt="moneyIcon" className={styles.headerIcon} />
        </BCol>
      </BRow>
      <BRow theme="mt-4">
        <BCol theme="text-center">
          <BTitle type="h4">{translateHTML(messages.FinanceProfession.bussDenial.title)}</BTitle>
        </BCol>
      </BRow>
      <BRow theme="mt-2">
        <BCol lg={1} theme="offset-1">
          <img src={tickDone} alt="" className={styles.tickIcon} />
        </BCol>
        <BCol lg={10}>{translate(messages.FinanceProfession.bussDenial.tick1)}</BCol>
      </BRow>
      <BRow theme="mt-1">
        <BCol lg={1} theme="offset-1">
          <img src={tickDone} alt="" className={styles.tickIcon} />
        </BCol>
        <BCol lg={10}>{translate(messages.FinanceProfession.bussDenial.tick2)}</BCol>
      </BRow>
      <BRow theme="mt-4">
        <BCol lg={12} theme="text-center">
          <BButton
            messages={{
              message: translate(messages.FinanceProfession.bussDenial.button),
            }}
            onClick={goToBusinessLoan}
            color="primary"
            testid="officeBtn"
          />
        </BCol>
      </BRow>
    </BCardBody>
  )
}

export default BusinessDenial
